import Menu from '@mui/material/Menu'
import IconButton from '@mui/material/IconButton'
import React, { Fragment, memo, useCallback, useMemo, useState } from 'react'
import tw from 'twin.macro'
import { SvgIcon, Tooltip } from '@mui/material'
import { Columns3Minor } from '@shopify/polaris-icons'
import { GridColumnsSelectContent } from './GridColumnsSelectContent'
import { GridColDef, GridColumnVisibilityModel, GridPinnedColumns } from '@mui/x-data-grid-pro'

interface Props {
  columnsConfig: Array<GridColDef>
  columnVisibilityModel: GridColumnVisibilityModel
  pinnedColumns?: GridPinnedColumns
  lockedColumns?: Array<string>
  onToggleColumnVisibility(field: string): void
  onColumnVisibilityModelChange(model: GridColumnVisibilityModel): void
  onPinColumn?(field: string): void
  onUnpinColumn?(field: string): void
}

const GridColumnsSelectComponent = ({
  columnsConfig,
  columnVisibilityModel,
  lockedColumns = [],
  onToggleColumnVisibility,
  onColumnVisibilityModelChange,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const isMenuOpen = useMemo(() => {
    return Boolean(anchorEl)
  }, [anchorEl])

  const handleOpen = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  return (
    <Fragment>
      <Tooltip title="Manage columns">
        <IconButton
          id="grid-columns-select-button"
          aria-controls={isMenuOpen ? 'grid-columns-select-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={handleOpen}
          css={[
            tw`w-9 h-9 border border-solid border-[#EDEDED] rounded-lg`,
            isMenuOpen && tw`bg-gray-100`,
          ]}
        >
          <SvgIcon css={tw`w-5 h-5 text-black`}>
            <Columns3Minor color="black" />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      <Menu
        id="grid-columns-select-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'grid-columns-select-button',
          disablePadding: true,
        }}
        css={tw`mt-2`}
        PaperProps={{
          style: { borderRadius: 12, minWidth: 240 },
        }}
      >
        <GridColumnsSelectContent
          columnsConfig={columnsConfig}
          columnVisibilityModel={columnVisibilityModel}
          lockedColumns={lockedColumns}
          onToggleColumnVisibility={onToggleColumnVisibility}
          onColumnVisibilityModelChange={onColumnVisibilityModelChange}
        />
      </Menu>
    </Fragment>
  )
}

export const GridColumnsSelect = memo(GridColumnsSelectComponent)
